import React, { useEffect, useState } from "react";
import styles from "./AccountSettings.module.css";
import MenuButton from "./MenuButton";
import Header from "../Header/Header";
import config from "../../config";
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { useProfile } from "../../contexts/ProfileContext";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AccountIcon from "../../assets/images/a.png";
import SignSecurity from "../../assets/images/b.png";
import ManageAccount from "../../assets/images/c.png";
import SavedSearch from "../../assets/images/d.png";
import Notif from "../../assets/images/carbon_notification-new.png";
import SavedHome from "../../assets/images/f.png";
import Favorites from "../../assets/images/g.png";
import Payement from "../../assets/images/h.png";
import CustomerIcon from "../../assets/images/streamline_customer-support-1.png";
import { MdOutlineAddToPhotos, MdOutlinePayments, MdOutlinePrivacyTip, MdOutlineSecurity, MdVerified } from "react-icons/md";
import { getApi } from "../AppApis";
import { FiEdit } from "react-icons/fi";
import { IoHomeOutline } from "react-icons/io5";
import { RiCustomerServiceLine } from "react-icons/ri";
import { FaUserAlt } from "react-icons/fa";
const menuItems = [
    {
        category: "Account",
        items: [
            { name: "Sign In & Security", icon: <MdOutlineSecurity />, link: "/sign-in-security" },
            { name: "Get Verified", icon: <MdVerified />, link: "/start-verification" },
        ],
    },
    {
        category: "Support& Policies",
        items: [
            { name: "Customer Support", icon: <RiCustomerServiceLine />, link: "/chat" },
            { name: "Privacy Policy", icon: <MdOutlinePrivacyTip />, link: "/privacy-policy" },
        ],
    },
];
const menuItemsSecondColomn = [
    {
        category: "Saved & Favorites",
        items: [
            { name: "Saved Searches", icon: <MdOutlineAddToPhotos />, link: "/saved-searches" },

            { name: "Saved & Favorite Homes", icon: <IoHomeOutline />, link: "/favorites" },
        ],
    },
];

function AccountSettings() {
    const [profile, setProfile] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        role: "",
    });
    const [profileImageUrl, setProfileImageUrl] = useState();
    const navigate = useNavigate();
    const { profileData } = useProfile();

    const fetchProfile = async () => {
        const accessToken = localStorage.getItem("authUser");
        if (accessToken) {
            const token = accessToken.replace(/^"|"$/g, "");
            const profileUrl = `/user/profile`;
            const response = await getApi(profileUrl);

            if (response?.error === 401) {
                navigate("/login");
            } else if (response.response) {
                const data = response?.response?.data;

                setProfile({
                    firstName: data.first_name,
                    lastName: data.last_name,
                    email: data.email,
                    phone: data.phone || data?.profile_pic,
                    role: data.role,
                });
                localStorage.setItem("userName", data.first_name + " " + data.last_name);
                if (!data.profile_pic) {
                    setProfileImageUrl();
                } else {
                    setProfileImageUrl(`${config.get("API_URL")}/${data.profile_pic}`);
                }
            }
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    const renderProfileImage = () => {
        if (profileData?.profile_pic) {
            return (
                <img
                    src={`${config.get("IMAGE_BASE_URL")}${profileData.profile_pic}`}
                    alt="Profile"
                    className="tw-h-[70px] tw-w-[70px] tw-rounded-full tw-object-cover"
                />
            );
        } else if (profileImageUrl) {
            return (
                <img
                    src={`${config.get("IMAGE_BASE_URL")}${profileImageUrl}`}
                    alt="Profile"
                    className="tw-w-[50px] tw-h-[50px] tw-rounded-full tw-object-cover"
                />
            );
        } else if (profile.firstName && profile.lastName) {
            return (
                <div className="tw-bg-[#208177] tw-w-[50px] tw-h-[50px] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-lg tw-font-bold tw-text-white">
                    {profile.firstName[0]}
                    {profile.lastName[0]}
                </div>
            );
        } else {
            return <FaUserAlt className="tw-w-[50px] tw-h-[50px] tw-rounded-full tw-object-cover" />;
        }
    };

    const handleAccountClick = () => {
        navigate("/profile-detail", { state: { profile, profileImageUrl } });
    };

    const logout = () => {
        // Clear tokens from both localStorage and sessionStorage
        localStorage.removeItem("authUser");
        localStorage.removeItem("refreshToken");
        sessionStorage.removeItem("authUser");
        sessionStorage.removeItem("refreshToken");
        setProfile({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            role: "",
        });
        setProfileImageUrl();
        navigate("/login");
    };
    useEffect(() => {
        document.title = `Settings | ${config.get("COMPANY_NAME")}`;
    }, []);

    const handleGetVerification = () => {
        navigate("/start-verification");
    };

    return (
        <div className="tw-bg-background_color tw-h-screen tw-overflow-y-auto">
            <Header title="Settings" />
            <section className={styles.accountSettings}>
                <div className="tw-flex tw-w-full tw-justify-between tw-mt-[10px]">
                    <h2 className="tw-text-[32px] tw-font-[600]">Settings</h2>
                </div>
                <div className={`${styles.userProfile} tw-p-[15px] tw-mt-[20px]`}>
                    <div className={styles.userInfo}>
                        <Avatar className={`${styles.avatar} tw-h-[70px] tw-w-[70px]`} alt="User">
                            {renderProfileImage()}
                        </Avatar>
                        <div className={styles.nameContainer}>
                            {/* <span className={styles.label}>Name:</span> */}
                            <span className={"tw-font-semibold"}>
                                {" "}
                                {profile.firstName} {profile.lastName}
                            </span>
                            <span className={"tw-text-light_text"}> {profile.email}</span>
                        </div>
                    </div>
                    <button className="" onClick={handleAccountClick}>
                        <FiEdit className="tw-text-[24px]" />
                    </button>
                </div>
                <nav className={styles.menuContainer}>
                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-[40px]">
                        <div className="tw-flex tw-flex-col tw-gap-[30px]">
                            {menuItems.map((item, index) => (
                                <div key={index} className="tw-flex tw-flex-col tw-gap-[15px]">
                                    <h3 className="tw-font-semibold tw-text-[16px]">{item.category}</h3>
                                    <div className="tw-flex tw-flex-col tw-gap-[10px]  tw-rounded-xl">
                                        {item.items.map((itm) => (
                                            <MenuButton
                                                key={index}
                                                icon={itm.icon}
                                                image={itm?.image}
                                                text={itm.name}
                                                link={itm.link}
                                                HtmlIcon={itm?.HtmlIcon}
                                            />
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {menuItemsSecondColomn.map((item, index) => (
                            <div className="tw-flex tw-flex-col tw-gap-[15px]">
                                <h3 className="tw-font-semibold tw-text-[16px]">{item.category}</h3>
                                <div className="tw-flex tw-flex-col tw-gap-[10px]  tw-rounded-xl">
                                    {item.items.map((itm) => (
                                        <MenuButton
                                            key={index}
                                            icon={itm.icon}
                                            image={itm?.image}
                                            text={itm.name}
                                            link={itm.link}
                                            HtmlIcon={itm?.HtmlIcon}
                                        />
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* {menuItems.map((item, index) => (
                        <MenuButton
                            key={index}
                            icon={item.icon}
                            text={item.text}
                            link={item.link}
                            HtmlIcon={item?.HtmlIcon}
                            onClick={item.text === "Account" ? handleAccountClick : null}
                        />
                    ))} */}
                </nav>
                <button onClick={logout} className={`${styles.logoutButton} tw-text-light_text tw-border-[1px] tw-border-light_text`}>
                    Log Out
                </button>
            </section>
        </div>
    );
}

export default AccountSettings;
